<script>
  import { planets } from "../js/stores.js"
  import { planetAnim } from "../js/animations.js"

  import { gsap, Power2 } from "gsap"
  import { onMount } from "svelte"

  // $: if ($planets.length > 0) {
  //   planetAnim()
  // }

  onMount(() => {})
</script>

<div id="planet" />

<style>
  #planet {
    width: 80vw;
    height: 80vh;
    top: 0;
    left: 0;
    position: absolute;
    /* background: url("../images/planets/SATURN02.jpg"); */
    background-size: contain;
    background-repeat: no-repeat;
    z-index: -10;
    opacity: 1;
  }
</style>
